import React from "react";
import { Icon } from "../../";
import { useIntegrationSync } from "../../../../hooks";

const SyncButtons = ({ businessId, integrationId, disabled = false }) => {
  const { syncBusiness, syncMenu, isSyncingBusiness, isSyncingMenu } =
    useIntegrationSync({ businessId, integrationId });

  const handleSyncBusiness = () => {
    syncBusiness();
  };

  const handleSyncMenu = () => {
    syncMenu();
  };

  return (
    <div className="flex gap-2">
      {/* Sync Business Button */}
      <button
        onClick={handleSyncBusiness}
        disabled={disabled || isSyncingBusiness}
        className="inline-flex flex-1 items-center justify-center rounded-lg border border-blue-500/30 bg-blue-900/20 px-4 py-2 text-sm font-medium text-blue-400 transition-colors hover:border-blue-400/50 hover:bg-blue-900/30 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isSyncingBusiness ? (
          <div className="mr-2 h-4 w-4 animate-spin rounded-full border-b-2 border-blue-400"></div>
        ) : (
          <Icon name="RefreshCw" className="mr-2 h-4 w-4" />
        )}
        Sync Business
      </button>

      {/* Sync Menu Button */}
      <button
        onClick={handleSyncMenu}
        disabled={disabled || isSyncingMenu}
        className="inline-flex flex-1 items-center justify-center rounded-lg border border-blue-500/30 bg-blue-900/20 px-4 py-2 text-sm font-medium text-blue-400 transition-colors hover:border-blue-400/50 hover:bg-blue-900/30 disabled:cursor-not-allowed disabled:opacity-50"
      >
        {isSyncingMenu ? (
          <div className="mr-2 h-4 w-4 animate-spin rounded-full border-b-2 border-blue-400"></div>
        ) : (
          <Icon name="RefreshCw" className="mr-2 h-4 w-4" />
        )}
        Sync Menu
      </button>
    </div>
  );
};

export default SyncButtons;
